import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Column, resolveTagSeverity } from 'src/app/ui/tables';
import { ContactCardUrlPipe } from '../../pipes/contact-card-url.pipe';
import { TagModule } from 'primeng/tag';
import { IconService } from '../../icon.service';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { RootsUrlPipe } from '../../pipes/roots-url.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'primeng/tooltip';
import { TruncatePipe } from "../../pipes/truncate.pipe";


/**
 * @deprecated Use the table-columns component instead.  This one causes table layout issues in some cases due to the extra component elements anglar wraps the td elements in.
 */
@Component({
  selector: 'app-table-column',
  imports: [DatePipe, CurrencyPipe, ContactCardUrlPipe, TitleCasePipe, TagModule, TableModule, CommonModule, RootsUrlPipe, FontAwesomeModule, TooltipModule],
  standalone: true,
  templateUrl: './table-column.component.html',
  styleUrl: './table-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableColumnComponent implements OnInit {

  readonly resolveTagSeverity = resolveTagSeverity

  column = input.required<Column<any>>()
  data = input.required<any>()


  tooltipVisible = computed(() => {
    return this.column().includeTooltip && this.tooltipValue();
  })

  tooltipValue = computed(() => {
    const column = this.column();
    const data = this.data();
    let tooltip = data[column.field]

    if (column.includeTooltip) {
      if (typeof column.tooltipValue === 'string') {
        tooltip = column.tooltipValue;
      }
      else if (column.tooltipValue && typeof column.tooltipValue === 'object' && 'field' in column.tooltipValue) {
        tooltip = data[column.tooltipValue.field];
      }
      else if (column.tooltipValue && typeof column.tooltipValue === 'function') {
        tooltip = column.tooltipValue(data);
      }
    }

    return tooltip;
  })

  style = computed(() => {
    const column = this.column();
    const data = this.data();

    if (column.styleFunction) {
      return column.styleFunction(data);
    }
    else if (column.type === 'boolean') {
      if (column.highlightTrue && data[column.field]) {
        return {'color': 'var(--p-success-500)'}
      }
      else if (column.highlightFalse && !data[column.field]) {
        return {'color': 'var(--p-danger-500)'}
      }
      else {
        return {}
      }
    }
    else {
      return {}
    }

  })

  @ViewChild('template', {static: true}) template: any;

  constructor(
    private viewContainerRef: ViewContainerRef,
    public icons: IconService
  ) {}

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template)
  }
 
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  formatPercentage(value: string | number): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) return '0.00';
    
    if (num >= 0 && num <= 1) {
      return (num * 100).toFixed(0);
    }
    
    return num.toFixed(0);
  }

}
